var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"room-back",attrs:{"src":require("../../../../assets/image/live/back.png")},on:{"click":_vm.back}})}
var staticRenderFns = []

export { render, staticRenderFns }